<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M13.2405 7.09221C13.22 6.38507 13.1655 5.66789 13.0769 4.90734C12.911 3.48208 11.7076 2.35045 10.2195 2.28146C9.19094 2.23377 8.14025 2.20898 6.9999 2.20898C5.85956 2.20898 4.80886 2.23377 3.78031 2.28146C2.29222 2.35045 1.08882 3.48208 0.922871 4.90734C0.692376 6.88691 0.692377 8.57269 0.922871 10.5523C1.08882 11.9775 2.29222 13.1091 3.78031 13.1781C4.80886 13.2258 5.85956 13.2506 6.9999 13.2506H7.3125" stroke="#1A2653" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.25195 0.75V3.5" stroke="#1A2653" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.74805 0.75V3.5" stroke="#1A2653" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.75 5.75014L3.75002 9.75M3.75 5.75L7.74998 9.74986" stroke="#1A2653" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.25 12.0625L10.8864 13.75C11.6564 11.5381 12.2977 10.5675 13.75 9.25" stroke="#1A2653" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
const cancellationCalendarIcon = {
    name: 'cancellationCalendarIcon',
}
export default cancellationCalendarIcon
export { cancellationCalendarIcon }
</script>
